import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { TypoTitle } from "../About";
import Icon from "@/components/icon/Icon";
import { Edit, Sizes } from "@/components/icon/IconList";
import { usePagination } from "@/hooks/usePaginationNew";
import useSearchParams from "@/hooks/useSearchParams";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { BRAND_NOTICE_DETAIL_PAGE, BRAND_NOTICE_NEW_PAGE } from "@/settings/constant";
import { Button, Pagination } from "@bookips/solvook-ui-library";
import dayjs from "dayjs";
import Link from "next/link";
import { getBrandNotices } from "src/api/brand";
import { useBrandStore } from "../BrandProvider";
import EmptyArea from "../EpmtyArea";
import BoardListItem from "./BoardListItem";
const BrandNotices = ()=>{
    var _user_brand;
    const theme = useTheme();
    const name = useBrandStore((state)=>state.brand.name);
    const brandTitle = useBrandStore((state)=>state.brand.title);
    const { user  } = useAuthStore();
    const searchParams = useSearchParams();
    const { isMobile  } = useWindowDimensions();
    const { data: noticeListItems  } = useQuery([
        "brandNotices",
        name,
        searchParams.toString()
    ], ()=>getBrandNotices({
            name,
            offset,
            limit: 10
        }), {
        select: (data)=>{
            return {
                ...data.pagination,
                data: data.data.map((item)=>({
                        ...item,
                        createdAt: "".concat(dayjs(item.createdAt).format("YYYY.MM.DD HH:mm"))
                    }))
            };
        }
    });
    var _noticeListItems_total;
    const { offset , currentPage , onChangePage , totalPage  } = usePagination({
        limit: 10,
        totalCount: (_noticeListItems_total = noticeListItems === null || noticeListItems === void 0 ? void 0 : noticeListItems.total) !== null && _noticeListItems_total !== void 0 ? _noticeListItems_total : 0,
        isUseAsPath: true
    });
    return /*#__PURE__*/ _jsxs(Box, {
        sx: {
            margin: "0 20px",
            display: "flex",
            flexDirection: "column",
            gap: "32px"
        },
        children: [
            /*#__PURE__*/ _jsxs(TypoTitle, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                children: [
                    "공지 게시판",
                    name === ((_user_brand = user.brand) === null || _user_brand === void 0 ? void 0 : _user_brand.name) && /*#__PURE__*/ _jsx(Button, {
                        variant: "filledSecondary",
                        size: isMobile ? "small" : "medium",
                        href: BRAND_NOTICE_NEW_PAGE(name),
                        onClick: ()=>{
                            //mx-244
                            mixpanelEvent("Create Post Button Click", {
                                Position: "Brand Notice List",
                                "Brand Name": brandTitle,
                                "Button Name": "글쓰기"
                            });
                        },
                        sx: {
                            width: "fit-content",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px"
                        },
                        label: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    icon: Edit,
                                    color: theme.palette.primary.main,
                                    size: Sizes.smallHalf
                                }),
                                "글쓰기"
                            ]
                        })
                    })
                ]
            }),
            (noticeListItems === null || noticeListItems === void 0 ? void 0 : noticeListItems.data.length) === 0 ? /*#__PURE__*/ _jsx(EmptyArea, {
                text: "등록된 공지가 없어요."
            }) : /*#__PURE__*/ _jsxs(Box, {
                component: "ul",
                children: [
                    noticeListItems === null || noticeListItems === void 0 ? void 0 : noticeListItems.data.map((item)=>{
                        return /*#__PURE__*/ _jsxs(Link, {
                            href: BRAND_NOTICE_DETAIL_PAGE(name, item.postId),
                            onClick: ()=>{
                                //mx-241
                                mixpanelEvent("Brand Notice Clicked", {
                                    "Brand Name": brandTitle,
                                    "Post Title": item.title
                                });
                            },
                            children: [
                                /*#__PURE__*/ _jsx(BoardListItem, {
                                    ...item,
                                    isPrivate: false
                                }),
                                /*#__PURE__*/ _jsx(Divider, {
                                    sx: {
                                        margin: "32px 0"
                                    }
                                })
                            ]
                        }, item.postId);
                    }),
                    /*#__PURE__*/ _jsx(Pagination, {
                        page: currentPage,
                        onChange: (event, page)=>onChangePage(page),
                        count: totalPage,
                        size: "medium",
                        sx: {
                            "& ul": {
                                justifyContent: "center"
                            }
                        }
                    })
                ]
            })
        ]
    });
};
export default BrandNotices;
